module.exports = __webpack_public_path__ + "img/DAVID_CANNON_21-rs.9c154f97.jpg";